import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
/**
 * 文本框组件，继承Base
 * @module $ui/components/my-switch
 */

import { Switch } from 'element-ui';
import Base from '../Base';
export default {
  name: 'MySwitch',
  mixins: [Base],
  components: {
    ElSwitch: Switch
  },
  props: {
    value: [Boolean, String, Number]
  },
  methods: {
    getDefaultValue: function getDefaultValue() {
      return false;
    }
  },
  render: function render() {
    var _this = this;
    var h = arguments[0];
    var vnode = h("ElSwitch", {
      "ref": 'comp',
      "class": 'my-switch',
      "props": _objectSpread({}, this.innerProps),
      "on": _objectSpread({}, this.$listeners),
      "attrs": _objectSpread({}, this.innerProps),
      "model": {
        value: _this.fieldValue,
        callback: function callback($$v) {
          _this.fieldValue = $$v;
        }
      }
    });
    return this.renderComponent(vnode);
  },
  mounted: function mounted() {
    this.extendMethods(this.$refs.comp, ['focus']);
  }
};